export const noticedetail = [

  { id: 2, img: "/images/notice/id-2.png" },
  { id: 3, img: "/images/notice/id-3.png" },
  { id: 4, img: "/images/notice/id-4.png" },
  { id: 5, img: "/images/notice/id-5.png" },
  { id: 6, img: "/images/notice/id-6.png" },
  { id: 7, img: "/images/notice/id-7.png" },
  { id: 8, img: "/images/notice/id-8.png" },
  { id: 9, img: "/images/notice/id-9.png" },
  { id: 10, img: "/images/notice/id-10.png" },
  { id: 11, img: "/images/notice/id-11.png" },
  { id: 12, img: "/images/notice/id-12.png" },
  { id: 13, img: "/images/notice/id-13.png" },
  { id: 14, img: "/images/notice/id-14.png" },
  { id: 15, img: "/images/notice/id-15.png" },
  { id: 16, img: "/images/notice/id-16.png" },
  { id: 17, img: "/images/notice/id-17.png" },
  { id: 18, img: "/images/notice/id-18.png" },
  { id: 19, img: "/images/notice/id-19.png" },
  { id: 20, img: "/images/notice/id-20.png" },
  { id: 21, img: "/images/notice/id-21.png" },
  { id: 22, img: "/images/notice/id-22.png" },
  { id: 23, img: "/images/notice/id-23.png" }
];
